import "preact/debug"
import { createHashHistory } from "history"
import { render } from "htm/preact"
import Router, { route } from "preact-router"

import { trackEvent } from "../utils/analytics"
import { ElfsightPopup } from "../utils/fw"

import { Navbar } from "./components/Navbar"
import { Room } from "./components/Room"

import * as roomSources from "./rooms"
import { CometChat } from "src/50304/components/CometChat"

const rooms = Object.values(roomSources)

const popups = [
	{
		ID: "c777676d-fe07-40d3-ba29-f13aa4f341de",
		trigger: "quadient2021-languages",
	},
	{
		ID: "0ac1bcdb-7530-4eac-aad8-77e23cdcd4d3",
		trigger: "quadient2021-pdfs-right",
	},
	{
		ID: "08c33dbd-ac9d-4748-8df3-6e15ac52c37d",
		trigger: "quadient2021-agendas",
	},
	{
		ID: "75f60d0e-d487-40a9-b7e0-10043e470ecf",
		trigger: "quadient2021-photobooth",
	},
	{
		ID: "7fe53122-ad06-4996-9576-5cdad6e75ede",
		trigger: "quadient2021-scav-hunt-submit",
	},
	{
		ID: "49927a51-76a3-416c-bb85-b7846ba2a4b0",
		trigger: "quadient2021-scav-hunt",
	},
	{
		ID: "b9fa92eb-fa8e-4498-9b40-ba49ae36b784",
		trigger: "quadient2021-pdfs",
	},
	{
		ID: "c0f08c5d-a101-403a-afde-63df0ee96093",
		trigger: "quadient2021-duck",
	},
	{
		ID: "46fd2810-9fe0-4aaf-bd48-ce5c941a759b",
		trigger: "quadient2021-cap",
	},
	{
		ID: "fb8d160d-9e1f-468a-992a-44852040488c",
		trigger: "quadient2021-blue",
	},
	{
		ID: "4a96ecea-57a1-4572-97b4-e46c45076ac1",
		trigger: "quadient2021-canon",
	},
	{
		ID: "898a7a08-a36d-4c5a-a9e1-9de192a90500",
		trigger: "quadient2021-cognizant",
	},
	{
		ID: "07d194dd-6fd7-477a-b298-e5e40ecac2b9",
		trigger: "quadient2021-quad",
	},
	{
		ID: "dba61a95-f375-488f-9113-1bf40f1d9605",
		trigger: "quadient2021-duck-download",
	},
]

const handleNewRoute = ({ previous, url }) => {
	// JS time works in milliseconds so for a 2h timeout we need:
	// 1000 ms per second * 3600 s per hour * 2 hours
	if (window.lastPageLoad && window.lastPageLoad < new Date() - 1000 * 3600 * 2) {
		window.location = "https://delltech.tkeventsregistration.com/ttfjan2022"
		route(previoous)
	}
	window.lastPageLoad = new Date()
	trackEvent({
		eventID: 57004,
		from: previous?.replace(/^\//g, "").replace(/^$/g, "Lobby") || null,
		to: url.replace(/^\//g, "").replace(/^$/g, "Lobby"),
		type: "Venue Navigation",
		userID: window.dataLayer[0]["Registrant ID"],
	})
}

render(
	<>
		<Navbar />
		<CometChat />
		<Router history={createHashHistory()} onChange={handleNewRoute}>
			{rooms.map(room => <Room {...room} path={room.path || room.name.replace(/ /g, "-").replace(/[^A-z-]/g, "")} />)}
		</Router>
		{popups.map(ElfsightPopup)}
		<script src="https://apps.elfsight.com/p/platform.js" defer />
	</>,
	document.getElementById("content"),
)